module.exports = __webpack_public_path__ + "img/lock.6ff77c0a.svg";